<script setup>
const { theme } = useTheme();
const route = useRoute();
const props = defineProps({
    mobile: { default: false }
});

const publicSiteData = useState('publicSiteData');
</script>

<template>
    <nav class="min-w-fit">
        <NuxtLink
            :class="[
                'font-light border-transparent transition-colors duration-300 text-gray-900',
                mobile ? 'py-2' : 'mr-4 md:mr-8 pb-1 border-b-4',
            ]"
            @mouseenter="e => e.target.style.borderColor = theme.medium"
            @mouseleave="e => e.target.style.borderColor = 'transparent'"
            :to="`/${route.params.site_slug}`"
        >
            <font-awesome :icon="['far', 'home']" class="mr-2 sm:hidden"></font-awesome>
            Home
        </NuxtLink>
        <NuxtLink
            :class="[
                'transition-colors duration-300 text-gray-900',
                mobile ? 'py-2' : 'mr-4 md:mr-8 pb-1 border-b-4',
                route.path.startsWith(`/${route.params.site_slug}/meetings`)
                    ? 'font-medium'
                    : 'font-light border-transparent'
            ]"
            :style="route.path.startsWith(`/${route.params.site_slug}/meetings`) ? { borderColor: theme.medium } : {}"
            @mouseenter="e => !route.path.startsWith(`/${route.params.site_slug}/meetings`) && (e.target.style.borderColor = theme.medium)"
            @mouseleave="e => !route.path.startsWith(`/${route.params.site_slug}/meetings`) && (e.target.style.borderColor = 'transparent')"
            :to="`/${route.params.site_slug}/meetings`"
        >
            <font-awesome :icon="['far', 'calendar']" class="mr-2 sm:hidden"></font-awesome>
            Meetings
        </NuxtLink>
        <NuxtLink
            v-if="publicSiteData.has_policies"
            :class="[
                'transition-colors duration-300 text-gray-900',
                mobile ? 'py-2' : 'mr-4 md:mr-8 pb-1 border-b-4',
                route.path.startsWith(`/${route.params.site_slug}/policies`)
                    ? 'font-medium'
                    : 'font-light border-transparent'
            ]"
            :style="route.path.startsWith(`/${route.params.site_slug}/policies`) ? { borderColor: theme.medium } : {}"
            @mouseenter="e => !route.path.startsWith(`/${route.params.site_slug}/policies`) && (e.target.style.borderColor = theme.medium)"
            @mouseleave="e => !route.path.startsWith(`/${route.params.site_slug}/policies`) && (e.target.style.borderColor = 'transparent')"
            :to="`/${route.params.site_slug}/policies`"
        >
            <font-awesome :icon="['far', 'list-tree']" class="mr-2 sm:hidden"></font-awesome>
            Policies
        </NuxtLink>
        <NuxtLink
            v-if="mobile"
            :class="[
                'transition-colors duration-300 text-gray-700 py-2',
                route.path.startsWith(`/${route.params.site_slug}/search`)
                    ? 'font-medium'
                    : 'font-light border-transparent'
            ]"
            :style="route.path.startsWith(`/${route.params.site_slug}/search`) ? { borderColor: theme.medium } : {}"
            @mouseenter="e => !route.path.startsWith(`/${route.params.site_slug}/search`) && (e.target.style.borderColor = theme.medium)"
            @mouseleave="e => !route.path.startsWith(`/${route.params.site_slug}/search`) && (e.target.style.borderColor = 'transparent')"
            :to="`/${route.params.site_slug}/search`"
        >
            <font-awesome :icon="['far', 'magnifying-glass']" class="mr-2 sm:hidden"></font-awesome>
            Search
        </NuxtLink>
    </nav>
</template>
